import { createSelector } from 'reselect';
import { filter } from '../transform';
import { columns, FILTER_TYPE } from '../../constants/data';
import getFilteredTags from './getFilteredTags';

const getCurrentArea = state => state.areas.currentArea;

/**
  @name getFilteredTagsOfArea
  Selector to obtain the filtered list of all tags of an area
*/
const getFilteredTagsOfArea = createSelector(
  [getFilteredTags, getCurrentArea],
  (tags, currentArea) => {
    if (currentArea && currentArea.id) {
      const filters = [{
        type: FILTER_TYPE.COLUMN,
        column: 'Area',
        accessor: 'areaId',
        value: currentArea.id,
        name: currentArea.name || currentArea.id
      }];
      return filter(tags, filters, columns);
    }
    return tags;
  }
);

export default getFilteredTagsOfArea;



// WEBPACK FOOTER //
// ./src/utils/selectors/getFilteredTagsOfArea.js